<template>
  <v-theme-provider :dark="dark">
        <v-col
          v-if="title || subtitle"
          cols="12"
          md="6"
          sm="12"
        >
          <base-subtitle
            v-if="subtitle"
            :title="subtitle"
            space="1"
          />

          <base-title
            :title="title"
            class="text-uppercase"
            space="1"
          />

          <base-divider :color="color" />
          <base-body
          space="6"
          >
          <v-list>
            <v-list-item
            v-for="(f, i) in features"
            :key=i
            >
             <v-list-item-icon>
              <v-icon color='primary'>mdi-check-circle</v-icon>
            </v-list-item-icon>
            {{ f.text }}
            </v-list-item>
          </v-list>
          </base-body>
        </v-col>
  </v-theme-provider>
</template>

<script>
  // Mixins
  import Heading from '@/mixins/heading'

  export default {
    name: 'BaseInfoCol',

    mixins: [Heading],

    props: {
      features: [],
      dark: Boolean,
      callout: String,
      extlink: String,
      color: {
        type: String,
        default: 'primary',
      },
      icon: String,
      subtitle: String,
      text: String,
      title: String,
    },
  }
</script>
